'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as SwitchPrimitive from '@radix-ui/react-switch';
import clsx from 'clsx';
import { AnimatePresence, domMax, LazyMotion, m, } from 'motion/react';
import { forwardRef, useCallback, useEffect, useId, useRef, useState, } from 'react';
import { Stack, Text } from '../../index.js';
import styles from './switch.module.css';
const properties = {
    small: {
        text: {
            size: 16,
            lh: 'extra-small',
        },
    },
    regular: {
        text: {
            size: 18,
        },
    },
    big: {
        text: {
            size: 22,
        },
    },
};
export const Switch = forwardRef(({ dimension = 'regular', labelPosition = 'end', className, label, checkedLabel, checked, onCheckedChange, defaultChecked, ...otherProps }, forwardedRef) => {
    const uid = useId();
    const labelRef = useRef(null);
    const [isChecked, setIsChecked] = useState(checked ?? defaultChecked);
    const [shouldShowCheckedLabel, setShowCheckedLabel] = useState(Boolean(checkedLabel));
    const handleCheckedChange = useCallback((checked) => {
        onCheckedChange?.(checked);
        setIsChecked(checked);
    }, [onCheckedChange]);
    useEffect(() => {
        setShowCheckedLabel(Boolean(checkedLabel));
    }, [checkedLabel]);
    return (_jsx(LazyMotion, { features: domMax, strict: true, children: _jsxs(Stack, { as: m.div, direction: labelPosition === 'end' ? 'row' : 'row-reverse', vAlign: "start", columnGap: 8, fill: false, inline: true, layout: true, layoutRoot: true, children: [_jsx(SwitchPrimitive.Root, { className: clsx(styles.Switch, className), "data-switch-dimension": dimension, ref: forwardedRef, id: uid, checked: isChecked, onCheckedChange: handleCheckedChange, defaultChecked: defaultChecked, ...otherProps, children: _jsx(SwitchPrimitive.Thumb, { asChild: true, children: _jsx(m.span, { className: styles.Thumb, layout: true, initial: false, transition: {
                                type: 'spring',
                                stiffness: 700,
                                damping: 50,
                            } }) }) }), _jsx(AnimatePresence, { initial: false, mode: "popLayout", children: label && (_jsxs(Text, { as: "label", className: styles.Label, lineHeight: properties[dimension].text.lh, htmlFor: uid, size: properties[dimension].text.size, ref: labelRef, children: [(!shouldShowCheckedLabel || (shouldShowCheckedLabel && !isChecked)) && (_jsx(m.span, { initial: {
                                    opacity: 0,
                                    x: -20,
                                }, exit: {
                                    opacity: 0,
                                    x: -20,
                                }, animate: {
                                    opacity: 1,
                                    x: 0,
                                }, children: label }, "label")), (shouldShowCheckedLabel && isChecked) && (_jsx(m.span, { exit: {
                                    opacity: 0,
                                    x: 20,
                                }, initial: {
                                    opacity: 0,
                                    x: 20,
                                }, animate: {
                                    opacity: 1,
                                    x: 0,
                                }, children: checkedLabel }, "label-checked"))] })) })] }) }));
});
